"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body className="flex min-h-screen items-center justify-center bg-black text-white">
        <div className="mx-auto max-w-md text-center px-4">
          <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-500/10 mx-auto">
            <svg
              className="h-8 w-8 text-red-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
              />
            </svg>
          </div>
          <h2 className="text-2xl font-semibold text-white">
            Something went wrong
          </h2>
          <p className="mt-2 text-sm text-muted">
            {error.message || "An unexpected error occurred. Please try again."}
          </p>
          {error.digest && (
            <p className="mt-1 text-xs text-dim">
              Error ID: {error.digest}
            </p>
          )}
          <button
            onClick={reset}
            className="mt-6 inline-flex items-center justify-center rounded-xl bg-white px-4 py-2 min-h-[48px] text-base font-medium text-black transition-colors hover:bg-white/90"
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
